import {
  faAngleLeft,
  faEye,
  faPenAlt,
  faPenToSquare,
  faTrashAlt,
  faUpload,
} from "@fortawesome/free-solid-svg-icons";
import "./Applicayion_Study_Program_Details.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Form, Table } from "react-bootstrap";
import Blue_btn from "../../common_btn/blue_btn/Blue_btn";
import Green_btn from "../../common_btn/green_btn/Green_btn";
import StepProgressBar from "./stepProgressBar/StepProgressBar";
import React from "react";
import Success_modal from "../../common_modal/success_modal/Success_modal";
import downloadAnimation from "../../../animation/success_lottie/Download_lottie.json";

const Applicayion_Study_Program_Details = ({
  schoolLogo,
  schoolName = " Toulouse Business School",
  address = "15 Pl. Vendôme, 75001 Paris, France",
  countryFlag = "https://flagcdn.com/w20/fr.png",
  bannerImg,
  onBack,
}) => {
  const [modalDownloadShow, setModalDownloadShow] = React.useState(false);
  return (
    <>
      <div className="back_btn_holder">
        <Button className=" back_btn" onClick={onBack}>
          <div className="back_icon_holder">
            <FontAwesomeIcon icon={faAngleLeft} />
          </div>
          Back
        </Button>
      </div>

      <div className="tbs_card Applicayion_Study_Program_Details">
        <div className="tbs_card_header">
          <div className="tbs_header_info">
            <img
              src={schoolLogo}
              alt={schoolName}
              className="tbs_school_logo"
            />
            <h5 className="tbs_school_name">{schoolName}</h5>
          </div>
          <div className="d-flex gap-3 align-items-center">
            <h5 className="tbs_address">{address}</h5>
            <img src={countryFlag} alt="flag" className="tbs_flag" />
          </div>
        </div>

        <div className="detail_banner_holder">
          {bannerImg && <img src={bannerImg} className="tbs_banner_img" />}
        </div>

        <div className="tbs_body">
          <section className="tbs_section">
            <p className="tbs_main_desc">
              Duration: <b>3 Years</b> | Type: <b>Undergraduate Program</b>
            </p>
          </section>

          <section className="tbs_section border_bottom_holder">
            <div className="details_text_holder pb-3">
              <div className="row">
                <div className="col-md-3">
                  <p>Application Status:</p>
                </div>
                <div className="col-md-3">
                  <p>Submitted Successfully</p>
                </div>
              </div>

              <div className="row">
                <div className="col-md-3">
                  <p>Application ID:</p>
                </div>
                <div className="col-md-3">
                  <p>APP-15654</p>
                </div>
              </div>

              <div className="row">
                <div className="col-md-3">
                  <p>Submission Date:</p>
                </div>
                <div className="col-md-3">
                  <p>12 Dec 2025</p>
                </div>
              </div>
            </div>
          </section>

          <section className="tbs_grid ">
            <div className="tbs_column border_bottom_holder">
              <h5 className="tbs_column_title">Application Progress</h5>
              <StepProgressBar activeStep={2} />

              <div className="details_text_holder">
                <div className="row">
                  <div className="col-md-3">
                    <p>Current Stage:</p>
                  </div>
                  <div className="col-md-3">
                    <p>Under Review</p>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-3">
                    <p>Last Updated:</p>
                  </div>
                  <div className="col-md-3">
                    <p>16 Dec 2025</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="tbs_column border_bottom_holder">
              <h5 className="tbs_column_title">Submitted Documents</h5>
              <div className="form_holder">
                <Form>
                  <div className="details_text_holder">
                    <div className="row mb-3">
                      <div className="col-md-3">
                        <Form.Check
                          label="Resume/CV"
                          name="group1"
                          type={"radio"}
                        />
                      </div>
                      <div className="col-md-3">
                        <div className="action_btn_holder">
                          <Button className="eye_btn action_btn_icon">
                            <FontAwesomeIcon icon={faEye} />
                          </Button>

                          <Button className="edit_btn action_btn_icon">
                            <FontAwesomeIcon icon={faPenToSquare} />
                          </Button>

                          <Button className="trash_btn action_btn_icon">
                            <FontAwesomeIcon icon={faTrashAlt} />
                          </Button>
                        </div>
                      </div>
                    </div>

                    <div className="row mb-3 ">
                      <div className="col-md-3">
                        <Form.Check
                          label="Passport Copy"
                          name="group1"
                          type={"radio"}
                        />
                      </div>
                      <div className="col-md-3">
                        <div className="action_btn_holder">
                          <Button className="eye_btn action_btn_icon">
                            <FontAwesomeIcon icon={faEye} />
                          </Button>

                          <Button className="edit_btn action_btn_icon">
                            <FontAwesomeIcon icon={faPenToSquare} />
                          </Button>

                          <Button className="trash_btn action_btn_icon">
                            <FontAwesomeIcon icon={faTrashAlt} />
                          </Button>
                        </div>
                      </div>
                    </div>

                    <div className="row mb-3">
                      <div className="col-md-3">
                        <Form.Check
                          label="Academic Certificates"
                          name="group1"
                          type={"radio"}
                        />
                      </div>
                      <div className="col-md-3">
                        <div className="action_btn_holder">
                          <Button className="eye_btn action_btn_icon">
                            <FontAwesomeIcon icon={faEye} />
                          </Button>

                          <Button className="edit_btn action_btn_icon">
                            <FontAwesomeIcon icon={faPenToSquare} />
                          </Button>

                          <Button className="trash_btn action_btn_icon">
                            <FontAwesomeIcon icon={faTrashAlt} />
                          </Button>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-3">
                        <Form.Check
                          label="Motivation Letter"
                          name="group1"
                          type={"radio"}
                        />
                      </div>
                      <div className="col-md-3">
                        <div className="action_btn_holder">
                          <Button className="upload_btn action_btn_icon">
                            <FontAwesomeIcon icon={faUpload} />
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                </Form>
              </div>
            </div>

            <div className="tbs_column border_bottom_holder">
              <h5 className="tbs_column_title">Payment Summary</h5>
              <div className="details_text_holder">
                <div className="row">
                  <div className="col-md-3">
                    <p>Invoice ID:</p>
                  </div>
                  <div className="col-md-3">
                    <p>INV 3000330</p>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-3">
                    <p>Paid Amount:</p>
                  </div>
                  <div className="col-md-3">
                    <p>€9,000</p>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-3">
                    <p>Pending Amount:</p>
                  </div>
                  <div className="col-md-3">
                    <p>€9,000</p>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-3">
                    <p>Total Amount:</p>
                  </div>
                  <div className="col-md-3">
                    <p>€9,000</p>
                  </div>
                </div>
              </div>
              <div className="btn_holder">
                <Green_btn btn_text={"Pay Now"} />
                <Blue_btn
                  btn_text={"Download Invoice"}
                  onClick={() => setModalDownloadShow(true)}
                />
              </div>
            </div>

            <div className="tbs_column ">
              <h5 className="tbs_column_title">Message from admin</h5>
              <div className="form_holder ">
                <Form>
                  <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Control
                      type="text"
                      placeholder="Please Complete your Remaining Payment"
                    />
                  </Form.Group>
                </Form>
              </div>
            </div>
          </section>
        </div>
      </div>
      <Success_modal
        show={modalDownloadShow}
        onHide={() => setModalDownloadShow(false)}
        message_text={"Downloading Invoice"}
        animationData={downloadAnimation}
      />
    </>
  );
};
export default Applicayion_Study_Program_Details;
